import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { UiAlpha } from '../../../styles/ui-alpha';

const safeArea = {
  top: 'env(safe-area-inset-top, 0px)',
  right: 'env(safe-area-inset-right, 0px)',
  bottom: 'env(safe-area-inset-bottom, 0px)',
  left: 'env(safe-area-inset-left, 0px)',
} as const;
const bottomInset = `calc(${safeArea.bottom} + var(--vv-layout-bottom-gap, 0px))`;

export const useStyles = makeStyles<Theme>()((theme) => ({
  paper: {
    maxWidth: 400,
    width: '100%',
    margin: theme.spacing(2),
    borderRadius: theme.spacing(2),
    backgroundColor: '#121212',
    backgroundImage: 'none',
    position: 'relative',
    padding: theme.spacing(3, 2, 2),
    boxSizing: 'border-box',
    [theme.breakpoints.down('md')]: {
      marginTop: `calc(${theme.spacing(2)} + ${safeArea.top})`,
      marginBottom: `calc(${theme.spacing(2)} + ${bottomInset})`,
      marginLeft: `calc(${theme.spacing(2)} + ${safeArea.left})`,
      marginRight: `calc(${theme.spacing(2)} + ${safeArea.right})`,
    },
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(0.5),
    color: theme.palette.grey[500],
    padding: theme.spacing(0.5),
    '&:hover': {
      backgroundColor: 'rgba(255,255,255,0.06)',
      color: theme.palette.grey[300],
    },
  },
  inner: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    paddingTop: theme.spacing(0.5),
  },
  iconBadge: {
    ...theme.mixins.appIconTintSquare,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
    width: 56,
    height: 56,
    marginBottom: theme.spacing(2),
    '& svg': {
      width: 28,
      height: 28,
    },
  },
  title: {
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: '1.25rem',
    lineHeight: 1.3,
    marginBottom: theme.spacing(1.5),
  },
  description: {
    color: theme.palette.grey[400],
    fontSize: '0.875rem',
    lineHeight: 1.5,
    marginBottom: theme.spacing(2),
    maxWidth: 320,
  },
  bulletList: {
    alignSelf: 'stretch',
    textAlign: 'left',
    margin: 0,
    padding: 0,
    listStyle: 'none',
    marginBottom: theme.spacing(3),
  },
  bulletItem: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.25),
    marginBottom: theme.spacing(1),
    '&:last-child': {
      marginBottom: 0,
    },
  },
  bulletDot: {
    width: 6,
    height: 6,
    borderRadius: '50%',
    backgroundColor: theme.palette.primary.main,
    marginTop: '0.45rem',
    flexShrink: 0,
  },
  bulletText: {
    color: theme.palette.grey[300],
    fontSize: '0.875rem',
    lineHeight: 1.45,
  },
  primaryButton: {
    alignSelf: 'stretch',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    fontWeight: 700,
    fontSize: '0.9375rem',
    paddingTop: theme.spacing(1.25),
    paddingBottom: theme.spacing(1.25),
    borderRadius: theme.spacing(1),
    textTransform: 'none',
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
    '& svg': {
      width: 22,
      height: 22,
      color: theme.palette.common.white,
      flexShrink: 0,
    },
  },
  secondaryButton: {
    marginTop: theme.spacing(1.5),
    textTransform: 'none',
    color: theme.palette.grey[500],
    fontSize: '0.875rem',
    padding: theme.spacing(0.5, 1),
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.grey[400],
    },
    '& svg': {
      width: 20,
      height: 20,
      color: theme.palette.grey[500],
      flexShrink: 0,
    },
  },
}));
